import L from 'leaflet';

// Configuration des icônes pour la carte
export const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

// Initialiser l'icône par défaut
L.Marker.prototype.options.icon = DefaultIcon;

// Icône personnalisée pour les déménageurs
export const MoverIcon = L.divIcon({
  html: `<div class="p-1 bg-gray-800 rounded-full shadow-lg border border-amber-500"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg></div>`,
  className: "",
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});





